jQuery(document).ready(function () {
  jQuery(".mod-quote-block-v2").each(function (index) {
    let image_slider = jQuery(this).find(
      ".quote_section_secondary_main__left_image_slider"
    );
    let image_slide = image_slider.find(
      ".quote_section_secondary_main__left_image_slider_image "
    ).length;
    let content_slider = jQuery(this).find(
      ".quote_section_secondary_main__right_content_slider"
    );
    // let content_slide = content_slider.find(
    //   ".quote_section_secondary_main__right_content_slider_item"
    // );
    let prev_arrow = jQuery(this).find(
      ".quote_section_secondary_main_arrow_controls .prev_arrow"
    );
    let next_arrow = jQuery(this).find(
      ".quote_section_secondary_main_arrow_controls .next_arrow"
    );
    let slick_dots = jQuery(this).find(".quote_section_secondary_main__dots");
    jQuery(image_slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: jQuery(prev_arrow),
      nextArrow: jQuery(next_arrow),
      dots: image_slide > 1,
      infinite: false,
      appendDots: jQuery(slick_dots),
      asNavFor: content_slider,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
            autoplay: true,
          },
        },
      ],
    });
    jQuery(content_slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: jQuery(prev_arrow),
      nextArrow: jQuery(next_arrow),
      infinite: false,
      dots: false,
      asNavFor: image_slider,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
            autoplay: true,
          },
        },
      ],
    });
  });
});
